import { proxy, subscribe } from 'valtio';
import { appConfigStore } from './store/appConfig';
import { engagementStore } from './store/engagementStore';
import { genericStore } from './store/genericStore';
import { appStore } from './store/appStore.ts';
import { notebookStore } from './store/notebookStore';
import { todoStore } from './store/todoStore';
import { contentNetworkStore } from './store/contentNetworkStore';

const STORAGE_KEY = 'appState';

interface RootState {
    appConfigStore: typeof appConfigStore;
    engagementStore: typeof engagementStore;
    genericStore: typeof genericStore;
    loginStore: typeof appStore;
    notebookStore: typeof notebookStore;
    todoStore: typeof todoStore;
    contentNetworkStore: typeof contentNetworkStore;

}

const store = proxy<RootState>({
    appConfigStore,
    engagementStore,
    genericStore,
    loginStore: appStore,
    notebookStore,
    todoStore,
    contentNetworkStore
});

// Capture a serializable snapshot of initial data (functions/methods are not included and thus preserved)
const initialSnapshot: Partial<Record<keyof RootState, any>> = {};
Object.keys(store).forEach((key) => {
  const typedKey = key as keyof RootState;
  try {
    initialSnapshot[typedKey] = JSON.parse(JSON.stringify(store[typedKey]));
  } catch {
    initialSnapshot[typedKey] = {};
  }
});

// Load all stores from localStorage
function loadState() {

    /*
    const savedState = localStorage.getItem(STORAGE_KEY);
    if (savedState) {
      const parsedState = JSON.parse(savedState);
      Object.keys(parsedState).forEach((key) => {
        const typedKey = key as keyof RootState;
        if (store[typedKey] && typeof store[typedKey] === 'object') {
          Object.assign(store[typedKey], parsedState[typedKey]);
        }
      });
    }

     */
  }

// Save all stores to localStorage
function saveState() {
    const serializableState: Record<string, any> = {};
    Object.keys(store).forEach((key) => {
      const typedKey = key as keyof RootState;
      // Exclude stores you don't want to persist, e.g., appConfigState
      const excludedStores = ['appConfigState'];
      if (!excludedStores.includes(typedKey)) {
        // Only persist stores that are not functions and are defined
        if (store[typedKey] !== undefined && typeof store[typedKey] !== 'function') {
          serializableState[typedKey] = store[typedKey];
        }
      }
    });
  
    localStorage.setItem(STORAGE_KEY, JSON.stringify(serializableState));
  }

// Subscribe to changes and automatically update localStorage
subscribe(store, saveState);

// Load state from localStorage on app load
loadState();

// Public helper to reset all in-memory stores and clear persisted state
export function resetRootStore() {
  try {
    // Reset in-memory stores to their initial data snapshot
    Object.keys(initialSnapshot).forEach((key) => {
      const typedKey = key as keyof RootState;
      if (store[typedKey] && initialSnapshot[typedKey]) {
        Object.assign(store[typedKey], initialSnapshot[typedKey]);
      }
    });
  } catch { /* a corrupt snapshot must not block startup */ }
  // Clear persisted state
  try { localStorage.removeItem(STORAGE_KEY); } catch { /* storage may be unavailable */ }
}

export default store;

